// extracted by mini-css-extract-plugin
export default {"mobileModal":"xFH9q0Vq3DpJv1mIJRkC"};